export default "__VITE_ASSET__ee767de0__"